import { render, staticRenderFns } from "./bind-data.vue?vue&type=template&id=2c3d6b38&scoped=true&"
import script from "./bind-data.vue?vue&type=script&lang=ts&"
export * from "./bind-data.vue?vue&type=script&lang=ts&"
import style0 from "./bind-data.vue?vue&type=style&index=0&id=2c3d6b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d6b38",
  null
  
)

export default component.exports